import { useEffect } from 'react'

export default function InteractionMotion() {
  useEffect(() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)')
    const active = new Map<HTMLElement, Animation>()
    const activate = (event: MouseEvent) => {
      if (reduced.matches || !(event.target instanceof Element)) return
      const control = event.target.closest<HTMLElement>('button, a[href], [role="button"]')
      if (!control || control.closest('.constellation-card') || control.matches(':disabled, [aria-disabled="true"], .login-morph')) return
      active.get(control)?.cancel()
      const animation = control.animate([{ scale: '.96' }, { scale: '1.025', offset: .55 }, { scale: '1' }], { duration: 300, easing: 'cubic-bezier(.2,.8,.2,1)' })
      active.set(control, animation)
      animation.onfinish = () => { if (active.get(control) === animation) active.delete(control) }
    }
    const stop = () => { if (reduced.matches) { active.forEach(animation => animation.cancel()); active.clear() } }
    document.addEventListener('click', activate, true)
    reduced.addEventListener('change', stop)
    return () => { document.removeEventListener('click', activate, true); reduced.removeEventListener('change', stop); active.forEach(animation => animation.cancel()) }
  }, [])
  return null
}

